export default "__VITE_ASSET__e0d711f9__"